
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/gam360",
      function () {
        return require("private-next-pages/destinations/gam360.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/gam360"])
      });
    }
  